import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from "@angular/core";
import {FormGroup} from "@angular/forms";
import {DocumentoDTO} from "../../models/documento-dto";
import {TipoDocumento} from "../../models/tipo-documento";
import {combineLatest, merge, Observable, Subject, Subscription} from "rxjs";
import {NewFile} from "./new-file";
import {debounceTime, map, scan, shareReplay, startWith, tap, withLatestFrom} from "rxjs/operators";
import {Tuple} from "../../models/tuple";
import {TipiDocumento} from "../../constants/tipi-documenti";
import {Modals} from "../../utils/modals";
import {TipologicaDTO} from "../../models/tipologica-d-t-o";
import {TipoDocumentoDTO} from "../../models/tipo-documento.dto";
import {Azione, GenericModalData} from "../../common-component/generic-modal/generic-modal-data";
import { CaricaDocumentiComponent } from '../../components/documentazione/carica-documenti/carica-documenti.component';

@Component({
	selector: 'lib-documentazione',
	templateUrl: './documentazione.component.html',
	styleUrls: ['./documentazione.component.css']
})
export class DocumentazioneComponent implements OnInit {

	form: FormGroup;

	//TODO
	allegatiMock = [{
		chiaveCollegamento: "7afe2d6c-5757-4684-91fc-387c7c15dbf6",
		dataCreazione: "2021-01-08",
		dataInizioStaging: "2021-01-08",
		dataStaging: "2021-01-08",
		dataValidazione: null,
		descrizione: "Test request10",
		idCreatore: "1",
		idDocumento: "ad397ac0-f017-48e1-98fb-3e4c514adbdb",
		idIstanza: "2380b34a-4b2d-4a9b-896b-ba4a27cdbf7f",
		jsonMetadati: "",
		nome: "fileditest10.txt",
		proprietario: { tipoProprietario: "PF", idProprietario: "1", idSottoProprietario: null },
		statiDocumento: [{ idDocumento: "ad397ac0-f017-48e1-98fb-3e4c514adbdb", stato: "DOC_VALID", dataCambiamentoStato: "2021-01-08", nota: null, lastState: true }],
		tipoDocumento: { id: "e617df75-0c3b-41a6-b7a0-c514ede2e9ee", codice: "CU", descrizione: "Certifcazione Unica" },
		tipoServizio: { id: "f2c7415f-5a20-4f14-a379-d07d0d1cbd9a", codice: "CU", descrizione: "Certificazione Unica" },
		url: "/v1/documento/ad397ac0-f017-48e1-98fb-3e4c514adbdb/download"
	}]

	//TODO
	// @Input()
	// documentazione: Array<DocumentoDTO>;

	@Input()
	documenti: Array<DocumentoDTO>;

	@Input()
	tipologieDocumento$: Observable<Array<TipoDocumentoDTO>>;

	@Input()
	tipologieTipiEmittenti$: Observable<Array<TipologicaDTO>>;

	@Output()
	nextStep = new EventEmitter<Array<NewFile>>();

	@Output()
	salvaBozza = new EventEmitter<Array<NewFile>>();

	@Output()
	previousStep = new EventEmitter<Array<NewFile>>();

	@ViewChild('caricaDocumenti')
	caricaDocumenti: CaricaDocumentiComponent;

	addFiles$: Subject<NewFile>;
	removeFile$: Subject<number>;
	files$: Observable<Array<NewFile>>;
	viewList$: Observable<boolean>;
	tipologieDocumentoAll$: Observable<Array<TipoDocumentoDTO>>;
	hasMissingFileTypes$: Observable<boolean>;
	missingFileTypes$: Observable<Array<TipoDocumento>>;
	direction = "both-ways";
	isFinal = false;
	avantiClicks$ = new Subject<any>();
	nomeColonne$: Observable<Array<string>>;
	mappatura$: Observable<Array<string>>;
	indietroClicks$ = new Subject<any>();
	subscription: Subscription;

	constructor(protected modals: Modals) { }

	ngOnInit() {

		this.form = new FormGroup({});

		if (!this.documenti) {
			this.initDocumnetazione();
		}

		this.addFiles$ = new Subject();
		this.removeFile$ = new Subject();

		this.removeFile$.subscribe(console.log);

		//------Si accumulano i documenti validi da inviare-------
		const adds$ = this.addFiles$.pipe(
			map((file: NewFile) => (acc: Array<NewFile>) => {
				if (file.file != null) {
					if (!file.file.name.toLowerCase().endsWith(".pdf")) {
						// this.modals.failure(["Si prega di inserire solamente file in formato pdf"]);
						this.modals.openConfirm(this.buildErrore("Si prega di inserire solamente file in formato pdf"));
						return acc;
					}
					if (file.file.size == 0) {
						// this.modals.failure(["Si prega di non inserire file vuoti"]);
						this.modals.openConfirm(this.buildErrore("zero-file-size"));
						return acc;
					}
					const fileExists = acc.find(loaded => loaded.file.name === file.file.name) != null;
					if (fileExists) {
						// this.modals.failure(["Si prega di inserire un file diverso da quelli che sono stati inserti"]);
						this.modals.openConfirm(this.buildErrore("Si prega di inserire un file diverso da quelli che sono stati inseriti"));
						return acc;
					}

					this.caricaDocumenti.resetForm();
				}
				//console.log("[file]", [...acc, file]);
				return [...acc, file];
			})
		);

		this.nomeColonne$ =
			new Observable(ob => ob.next(["nr._Documento", "tipo_Documento", "data_Documento", "tipologia_emittente", "organo_emittente", "obbligatorio"]));

		this.mappatura$ = this.addFiles$.pipe(map(file => Object.keys(file[0])))

		const removals$ = this.removeFile$.pipe(
			map((index: number) => (acc: Array<NewFile>) => {
				return acc.filter((_, i) => index !== i);
			})
		);

		this.files$ = merge(adds$, removals$).pipe(
			scan((acc, op) => op(acc), []),
			startWith([]),
			tap(_ => console.log("[DocumentazioneComponent] - metadatiDocumenti", _)),
			shareReplay()
		);

		this.viewList$ = this.files$.pipe(map(files => files.length > 0));

		const presentAndMissing$ = combineLatest(
			[this.files$, this.tipologieDocumento$]
		)
			.pipe(
				map(([files, tipologieDocumento]) => {
					const tipiDoc = tipologieDocumento
						? tipologieDocumento.filter(
							(t) => t.codice != TipiDocumento.ALTRO
						)
						: [];

					const missing = tipiDoc.filter((tipoDoc) => {
						const typeFound = files.find(
							(file) => file.tipoDocumento.codice == tipoDoc.codice
						);
						return typeFound ? false : true;
					});

					return Tuple.of(files, missing);
				}),
				shareReplay()
			);

		//scrivere l'errore
		this.hasMissingFileTypes$ = presentAndMissing$.pipe(
			map((t) => t._2.length > 0),
			startWith(false)
		);

		// //scrivere l'errore
		this.missingFileTypes$ = presentAndMissing$.pipe(map((t) => t._2));

		//emettere lista dei file caricati
		const present$ = presentAndMissing$.pipe(map((t) => t._1));

		this.subscription = this.avantiClicks$
			.pipe(
				debounceTime(250),
				withLatestFrom(present$),
				// tap(([_, present]) => console.log("[present]", present)),
				tap(([_, present]) => this.nextStep.emit(present))
			)
			.subscribe();

		this.tipologieDocumentoAll$ = this.tipologieDocumento$;
	}

	ngOnDestroy(): void {
		if (this.subscription) {
			this.subscription.unsubscribe();
		}
	}

	forward($event: any) {
		this.avantiClicks$.next($event);
	}

	backward(_: any) {
		this.previousStep.emit([]);
	}

	complete(_: any) { }

	onSalvaBozza(_: any) {
		this.salvaBozza.emit([]);
	}

	initDocumnetazione() {
		this.documenti = new Array<DocumentoDTO>();
	}

	buildErrore(msg: string): GenericModalData {
		const data = new GenericModalData();

		data.title = 'dialogTitleError';
		data.paragrafi =
			[ msg
			];
		const noOp = new Azione('ko');
		noOp.testo = 'KO';

		data.azioni = [noOp];
		return data;
	}

}
